import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Labs from "../pages/labs/Labs";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/labs",
    element: <Labs />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
